import React, { useEffect } from 'react'
import Head from 'next/head'
import { setPageViewData } from '../utils/analytics'

const Accessibility: React.FC = () => {
  useEffect(() => {
    setPageViewData('Other|Accessibility', 'Other', 'Accessibility')
  }, [])

  return (
    <div id="main-content">
      <Head>
        <title>pOpshelf Accessibility Statement</title>
        <meta
          name="description"
          content="pOpshelf is committed to making its website and apps accessible to everyone, including customers with disabilities."
        />
      </Head>
      <div className="privacy-policy" id="privacypolicy">
        <div className="privacy-policy__hero-ribbon">
          <h1>Accessibility Statement</h1>
        </div>
        <div className="privacy-policy__row">
          <p>
            At pOpshelf, one of our core values is building a culture that respects the dignity and differences of
            others, and is a driving force behind our success. pOpshelf is committed to making its website and apps
            accessible to everyone, including customers with disabilities.
          </p>
          <p>
            pOpshelf has retained a third-party digital accessibility and assistive technology testing partner to
            assist us in implementing the Web Content Accessibility Guidelines, version 2.0, Level AA (WCAG 2.0 AA)
            on our websites and apps. pOpshelf continues to make website accessibility a key focus of our software
            development and design efforts.
          </p>
        </div>
        <div className="privacy-policy__row">
          <h2>Need Assistance?</h2>
          <p>
            If you experience difficulty accessing our website or apps, you can share your feedback and get assistance
            from Customer Support at <a href="tel:+18333774353">833-3PSHELF (833-377-4353)</a>.
          </p>
          <p>
            We are committed to serving our customers and will be happy to assist.
          </p>
        </div>
      </div>
    </div>
  )
}

export const getServerSideProps = async () => {
  return {
    props: {}
  }
}

export default Accessibility
